import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { Currencies } from 'shared/types';

export function useExchangeRate(currency: Currencies | string) {
  const { quoteService } = useService();
  const { data, isLoading, isFetching } = useQuery<string, Error>(
    ['exchangerate', currency],
    () => quoteService.getExchangeRate(currency),
    {
      enabled: Boolean(currency),
    }
  );
  return { exchangeRate: data, isLoading, isFetching } as const;
}
